module.exports = __webpack_public_path__ + "images/814298405327e47b9b87dcd2e8b0367d772b6b5d4aea11d90ecbfdd62f70c1b1.svg";